var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRoundArrow = function SvgRoundArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32.578,
    height: 31.771,
    viewBox: "0 0 32.578 31.771",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol_1014",
    "data-name": "Symbol 1014",
    transform: "translate(-258 -352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_798",
    "data-name": "Symbol 798",
    transform: "translate(258 352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1492",
    "data-name": "Group 1492",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-66"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse-17",
    cx: 16.289,
    cy: 15.886,
    rx: 16.289,
    ry: 15.886,
    fill: "#07a3c8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "noun_685132_cc",
    transform: "translate(282.045 360.582) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1493",
    "data-name": "Group 1493",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M6.742.092.121,5.98A.363.363,0,0,0,.1,6.5a.427.427,0,0,0,.554.017l5.964-5.3V16.361a.39.39,0,0,0,.779,0V1.219l5.964,5.3a.425.425,0,0,0,.554-.017A.359.359,0,0,0,13.9,5.98L7.278.092a.437.437,0,0,0-.536,0Z",
    transform: "translate(0)",
    fill: "#fff"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRoundArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/roundArrow.aaf46012.svg";
export { ForwardRef as ReactComponent };